/**
 * Button
 * 
 */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Button = props => {
  const {
    action,
    className,
    icon,
    name,
    onBlur,
    onFocus,
    show,
    text
  } = props;
  if (!show) return null;
  return /*#__PURE__*/_jsxs("div", {
    className: `button secondary ${className}`,
    onClick: action,
    tabIndex: "0",
    role: "button",
    onBlur: onBlur,
    onFocus: () => onFocus(name),
    children: [/*#__PURE__*/_jsx("span", {
      className: "icon",
      children: /*#__PURE__*/_jsx(FontAwesomeIcon, {
        icon: icon
      })
    }), /*#__PURE__*/_jsx("span", {
      className: "text",
      children: text
    })]
  });
};
Button.defaultProps = {
  action: () => null,
  className: 'button',
  icon: 'crop-alt',
  onBlur: () => null,
  onFocus: () => null,
  name: 'edit',
  show: false,
  text: 'Crop'
};
export default Button;